import React, { PureComponent } from "react";
import { RadialBarChart, RadialBar, Legend } from "recharts";

const style = {
  top: 0,
  left: 350,
  lineHeight: "30px",
};

export default class RingChart extends PureComponent {
  render() {
    const fill = ["#8884d8", "#8dd1e1", "#a4de6c", "#ffc658"];
    const data = this.props.data.map((data, index) => ({
      name: data.x,
      uv: data.y,
      fill: fill[index],
    }));
    return (
      <>
        <h3>
          <span style={{ textTransform: "capitalize" }}>
            {this.props.heading}
          </span>{" "}
        </h3>
        <RadialBarChart
          width={500}
          height={300}
          cx={150}
          cy={150}
          innerRadius={20}
          outerRadius={140}
          barSize={25}
          data={data}
        >
          <RadialBar
            minAngle={15}
            label={{ position: "insideStart", fill: "#000" }}
            background
            clockWise
            dataKey="uv"
          />
          <Legend
            iconSize={10}
            width={120}
            height={140}
            layout="vertical"
            verticalAlign="middle"
            wrapperStyle={style}
          />
        </RadialBarChart>
      </>
    );
  }
}
